// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-title[data-v-156a4276]{transform:translateY(-50%)}.nuxt-link-active[data-v-156a4276]{background:#fff;color:#000}", ""]);
// Exports
module.exports = exports;
